import { HyperFormula } from 'hyperformula';
import { shouldEnableDebugFeatures } from '../../../debug/debugUtil';
import { useUSDateFormat } from '../../../../common/utils/timeUtil';

const BLACKLISTED_FUNCTIONS = [
    // Removed as we don't support array results yet
    // TODO: Remove once we support array results
    'ARRAYFORMULA',
    'ARRAY_CONSTRAIN',
    'MMULT',
    'MEDIANPOOL',
    'MAXPOOL',
    'TRANSPOSE',

    // Removed as these are non-standard functions
    'INTERVAL',
    'HF.ADD',
    'HF.CONCAT',
    'HF.DIVIDE',
    'HF.EQ',
    'HF.LTE',
    'HF.LT',
    'HF.GTE',
    'HF.GT',
    'HF.MINUS',
    'HF.MULTIPLY',
    'HF.NE',
    'HF.POW',
    'HF.UMINUS',
    'HF.UNARY_PERCENT',
    'HF.UPLUS',
];

const hyperFormulaInstance = HyperFormula.buildEmpty({
    licenseKey: 'internal-use-in-handsontable',

    // Using the default values for US and non US
    dateFormats: useUSDateFormat() ? ['MM/DD/YYYY', 'MM/DD/YY', 'YYYY/MM/DD'] : ['DD/MM/YYYY', 'DD/MM/YY'],
});

BLACKLISTED_FUNCTIONS.forEach((fnId: string) => {
    // @ts-ignore - private API
    const functionRegistry = hyperFormulaInstance._functionRegistry;
    if (!functionRegistry) return;

    functionRegistry.functions?.delete(fnId);
    functionRegistry.functionsMetadata?.delete(fnId);
    functionRegistry.instancePlugins?.delete(fnId);
    functionRegistry.arrayFunctions?.delete(fnId);
    functionRegistry.arraySizeFunctions?.delete(fnId);
});

export const hyperFormulaList = hyperFormulaInstance
    .getRegisteredFunctionNames()
    .sort()
    .sort((a: string, b: string) => a.length - b.length);

if (shouldEnableDebugFeatures()) {
    window.hyperFormulaInstance = hyperFormulaInstance;
}

export default hyperFormulaInstance;
